import { useEffect, useState } from "react";
import styles from "../../styles/chatStyles";

import { db } from "../../firebase";
import { doc, onSnapshot } from "firebase/firestore";

const DEFAULT_AVATAR =
  "https://ui-avatars.com/api/?background=222&color=fff&name=";

export default function MainTopBar({ toggleChats, onCreateGroup }) {
  const username = localStorage.getItem("user");
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    if (!username) return;

    const unsub = onSnapshot(doc(db, "users", username), (snap) => {
      if (snap.exists()) {
        setUserData(snap.data());
      }
    });

    return () => unsub();
  }, [username]);

  const avatarSrc =
    userData?.avatar && userData.avatar.trim() !== ""
      ? userData.avatar + "?t=" + Date.now()
      : DEFAULT_AVATAR +
        encodeURIComponent(userData?.name || username || "U");

  return (

    <div style={styles.mainTopBar}>

        <div
        onClick={onCreateGroup}
        style={{
            width: 36,
            height: 36,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 10,
            cursor: "pointer",
            marginRight: 8,

            background: "rgba(255,255,255,0.04)",
            border: "1px solid rgba(255,255,255,0.08)",

            transition: "all 0.2s ease",
        }}
        onMouseEnter={(e) => {
            e.currentTarget.style.background = "rgba(255,255,255,0.08)";
        }}
        onMouseLeave={(e) => {
            e.currentTarget.style.background = "rgba(255,255,255,0.04)";
        }}
        >
        {/* ➕ иконка */}
        <svg width="16" height="16" viewBox="0 0 24 24" stroke="white" fill="none">
            <path d="M12 5v14M5 12h14" strokeWidth="2" strokeLinecap="round"/>
        </svg>
        </div>

      <button
        onClick={toggleChats}
        style={{
            
          background: "transparent",
          border: "none",
          color: "#aaa",
          fontSize: 20,
          cursor: "pointer",
          marginRight: 10,
        }}
      >
        ☰
      </button>

      <img
        src={avatarSrc}
        style={styles.avatar}
        onError={(e) => {
          e.target.src =
            DEFAULT_AVATAR +
            encodeURIComponent(userData?.name || username || "U");
        }}
      />

      <span style={{ fontWeight: 600 }}>
        {userData?.name || username || "Загрузка..."}
      </span>
    </div>
  );
}